import mixpanel from 'mixpanel-browser';

const source = 'dashboard:annotation';

export default {
    trackStatus(status) {
        mixpanel.track(`${source}:view_annotation`, {
            Status: status ? 'on' : 'off'
        });
    },

    trackClick() {
        mixpanel.track(`${source}:annotation_clicked`);
    },

    trackLayerCreation() {
        mixpanel.track(`${source}:layer_created`);
    },

    trackCreation() {
        mixpanel.track(`${source}:annotation_created`);
    }
};
